import get from 'lodash/get'

export function safeAccountId (accountId, sdk) {
  return accountId ||
    get(sdk, 'token.accountId') ||
    get(sdk, 'wallet.accountId')
}

export function safePlatformId (platformId, sdk) {
  return platformId || sdk.platformId
}
